module.exports = __webpack_public_path__ + "img/exchangedollarline.286c6f80.svg";